(function () {
  function formatMoney(cents, format) {
    if (!format) {
      return '$' + (cents / 100).toFixed(2);
    }
    var value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function initPrimeProduct(root) {
    var sectionId = root.dataset.sectionId;
    var metaEl = document.getElementById('PrimeVariantMeta-' + sectionId);
    if (!metaEl) return;

    var variantMeta = [];
    try {
      variantMeta = JSON.parse(metaEl.textContent);
    } catch (e) {
      return;
    }

    var depositPercent = parseFloat(root.dataset.depositPercent || '10') / 100;
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    var skuEl = root.querySelector('[data-prime-sku]');
    var card1 = root.querySelector('[data-prime-card-1]');
    var card2 = root.querySelector('[data-prime-card-2]');
    var card3 = root.querySelector('[data-prime-card-3]');
    var priceEl = root.querySelector('[data-prime-price]');
    var compareEl = root.querySelector('[data-prime-compare]');
    var saveEl = root.querySelector('[data-prime-save]');
    var addBtnLabel = root.querySelector('[data-prime-add-label]');
    var depositEls = root.querySelectorAll('[data-prime-deposit]');
    var specValueEls = root.querySelectorAll('[data-prime-spec-value]');

    function resolveSpecValue(source, meta, fallback) {
      switch (source) {
        case 'variant_miles':
          return meta.card_1 || fallback || '—';
        case 'variant_grade':
          return meta.card_2 || fallback || '—';
        case 'variant_warranty':
          return meta.card_3 || fallback || '—';
        case 'variant_sku':
          return meta.sku || fallback || '—';
        default:
          return fallback || '—';
      }
    }

    function updateSpecValues(meta) {
      specValueEls.forEach(function (el) {
        var source = el.getAttribute('data-prime-spec-source');
        if (!source || source.indexOf('product_') === 0) return;
        el.textContent = resolveSpecValue(source, meta, el.textContent.trim());
      });
    }

    function findMeta(variantId) {
      return variantMeta.find(function (v) {
        return String(v.id) === String(variantId);
      });
    }

    function updateUI(variant) {
      if (!variant) return;
      var meta = findMeta(variant.id) || {};

      if (skuEl) {
        skuEl.textContent = variant.sku || meta.sku || '—';
      }
      if (card1) card1.textContent = meta.card_1 || '—';
      if (card2) card2.textContent = meta.card_2 || '—';
      if (card3) card3.textContent = meta.card_3 || '—';

      var price = variant.price;
      var compare = variant.compare_at_price || meta.compare_at_price || 0;

      if (priceEl) {
        priceEl.textContent = formatMoney(price, moneyFormat);
      }
      if (compareEl) {
        if (compare > price) {
          compareEl.textContent = formatMoney(compare, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (saveEl) {
        if (compare > price) {
          saveEl.textContent = 'Save ' + formatMoney(compare - price, moneyFormat);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
      if (addBtnLabel) {
        addBtnLabel.textContent = formatMoney(price, moneyFormat);
      }

      var deposit = Math.round(price * depositPercent);
      depositEls.forEach(function (el) {
        el.textContent = formatMoney(deposit, moneyFormat);
      });

      updateSpecValues(meta);
    }

    function handleVariantChange(data) {
      if (!data || !data.variant) return;
      if (data.sectionId && String(data.sectionId) !== String(sectionId)) return;
      updateUI(data.variant);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.productVariantChange, handleVariantChange);
    }

    document.addEventListener('product:variant-change', function (evt) {
      if (evt.detail && evt.detail.variant) {
        updateUI(evt.detail.variant);
      }
    });

    var initialId = root.querySelector('input[name="id"]');
    if (initialId && initialId.value) {
      var initial = findMeta(initialId.value);
      if (initial) {
        updateUI({
          id: initial.id,
          price: initial.price,
          compare_at_price: initial.compare_at_price,
          sku: initial.sku,
          title: initial.title,
        });
      }
    }
  }

  function initAccordions() {
    document.querySelectorAll('[data-prime-accordion]').forEach(function (accordion) {
      accordion.querySelectorAll('[data-prime-accordion-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-prime-accordion-item]');
          var isOpen = item.classList.contains('is-open');
          var singleOpen = accordion.closest('[data-prime-tabs]') === null;

          if (singleOpen) {
            accordion.querySelectorAll('[data-prime-accordion-item]').forEach(function (el) {
              el.classList.remove('is-open');
              el.querySelector('[data-prime-accordion-btn]').setAttribute('aria-expanded', 'false');
            });
          }

          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          } else if (!singleOpen) {
            item.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-prime-tabs]').forEach(function (tabsRoot) {
      var buttons = tabsRoot.querySelectorAll('[data-prime-tab]');
      var panels = tabsRoot.querySelectorAll('[data-prime-tab-panel]');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-prime-tab');

          buttons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (panel) {
            panel.classList.remove('is-active');
            panel.hidden = true;
          });

          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');

          var activePanel = tabsRoot.querySelector('[data-prime-tab-panel="' + target + '"]');
          if (activePanel) {
            activePanel.classList.add('is-active');
            activePanel.hidden = false;
          }
        });
      });
    });
  }

  document.querySelectorAll('[data-prime-product]').forEach(initPrimeProduct);
  initAccordions();
  initTabs();
})();
